import { getAuthHeaders } from "../../auth/services/getAuthHeaders";

export interface Folder {
  _id: string | number;
  name: string;
  user_id: string;
  created_at: string;
}

export async function fetchFolders(translatorServiceUrl: string): Promise<Folder[]> {
  const authHeaders = await getAuthHeaders();
  const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
  const res = await fetch(`${cleanedUrl}/folders`, {
    method: "GET",
    headers: authHeaders,
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch folders: ${res.status}`);
  }

  const data = await res.json();
  return data.folders || [];
}

export async function createFolder(translatorServiceUrl: string, name: string): Promise<string | number> {
  const authHeaders = await getAuthHeaders();
  const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
  const res = await fetch(`${cleanedUrl}/folders`, {
    method: "POST",
    headers: { ...authHeaders, "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });

  if (!res.ok) {
    throw new Error(`Failed to create folder: ${res.status}`);
  }

  const data = await res.json();
  return data.folder_id;
}

export async function renameFolder(
  translatorServiceUrl: string,
  folderId: string | number,
  name: string
): Promise<void> {
  const authHeaders = await getAuthHeaders();
  const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
  const res = await fetch(`${cleanedUrl}/folders/${folderId}`, {
    method: "PUT",
    headers: { ...authHeaders, "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });

  if (!res.ok) {
    throw new Error(`Failed to rename folder: ${res.status}`);
  }
}

export async function deleteFolder(translatorServiceUrl: string, folderId: string | number): Promise<void> {
  const authHeaders = await getAuthHeaders();
  const cleanedUrl = translatorServiceUrl.replace(/\/$/, "");
  const res = await fetch(`${cleanedUrl}/folders/${folderId}`, {
    method: "DELETE",
    headers: authHeaders,
  });

  if (!res.ok) {
    throw new Error(`Failed to delete folder: ${res.status}`);
  }
}
